import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"


import globalMU from "globalMU";
import {IItemOrcamento} from "../../types/IItemOrcamento";
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'
import * as gridItensActions from 'app/redux/gridItensSlice'
import { WindowMU } from "app/types/WindowMU";
import { ErroDaApi } from "app/api/classes/ErroDaApi";

declare var window:WindowMU

export type ExcluirItensParams = {
    itens: IItemOrcamento[]
}

export async function excluirItens(params: ExcluirItensParams) {
    try {
        globalMU.blockUI({tryPassiveLoading: true})
        
        const orcamentoAtualizado = await microuniversoApi.Orcamento.excluirItens(
            store.getState().orcamento.IdentificadorOrcamento,
            params.itens
        )
    
        
    
        const atualizarOrcamentoLegado = () => {
            // const orcamentoController = window.orcamentoController
            // const itemOrcamentoController = orcamentoController.itemOrcamentoController
    
            // if ((orcamentoController?.model?.get('ItensOrcamento')?.toJSON?.()?.length ?? 0) === params.itens.length) {
            //     orcamentoController.model.preVendas = [];
            //     orcamentoController.model.preVendasAdicionadas = undefined;
            // }

            const orcamentoLegado = window.orcamentoController.model

            orcamentoLegado.atualizar(orcamentoAtualizado, true, true)

            store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))

            store.dispatch(gridItensActions.atualizarFlagAction())
    
            // itemOrcamentoController.itensExcluidos(orcamentoAtualizado)
    
            
        }
    
        ////atualizarRedux()
        if (!("HasErrors" in orcamentoAtualizado && orcamentoAtualizado["ErrorLevel"] == "Error")) {
            atualizarOrcamentoLegado()
            globalMU.showSuccessMessage("Item(ns) excluído(s) com sucesso !")
        }
    } finally {
        globalMU.unblockUI()
    }
}
